var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"编辑资料","visible":_vm.editVisible,"maskClosable":false,"width":"80vw","centered":"","destroyOnClose":"","footer":null},on:{"cancel":_vm.onCancel}},[_c('expert-form',{ref:"EditForm",attrs:{"form":_vm.form,"isEdit":_vm.isEdit,"spinLoading":_vm.spinLoading},on:{"success":_vm.editSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }